interface Props {
    icon: string;
    text?: string;
}

export default function Icon(props: Props) {
    return (
        <div className="flex gap-x-3">
            <span className={`icon h-4 w-4 md:h-6 md:w-6 ${props.icon}`}></span>
            {props.text && <span className="md:text-regular text-sm">{props.text}</span>}
        </div>
    );
}
